module.exports = __webpack_public_path__ + "257d933843c1e335d4985b8e11ae1563.svg";